




import Vue from 'vue';
import WaitlistCard from '@/components/UI/WaitlistCard.vue';
import { DUNNING_WAITLIST_SIGNUP } from '@/store/action-types';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'DunningWaitlistCard',
  components: {
    WaitlistCard,
  },
  data() {
    return {
      DUNNING_WAITLIST_SIGNUP,
    }
  },
  computed: {
    ...mapGetters(['dunningWaitlist']),
  },
});
